module.exports = __webpack_public_path__ + "img/cotoclub3.894eebad.png";